import React from 'react';
import type { OpsKaizenData } from './useOpsKaizenData';
import { CARD_TITLE_CLASS, PANEL_CLASS, PANEL_HEADER_COMPACT } from './opsKaizenShared';

interface OpsKaizenSystemStatusProps {
  data: OpsKaizenData;
}

export const OpsKaizenSystemStatus: React.FC<OpsKaizenSystemStatusProps> = ({ data }) => (
  <div className={`${PANEL_CLASS} shrink-0`}>
    <div className={PANEL_HEADER_COMPACT}>
      <span className={CARD_TITLE_CLASS}>Status do Sistema</span>
      <span className="text-[9px] font-medium uppercase tracking-wider text-[var(--text-muted)]">
        Andon operacional
      </span>
    </div>
    <div className="grid gap-1.5 p-1.5 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)]">
      <div className="rounded-sm border border-[var(--border-default)]/60 bg-[var(--bg-elevated)]/30 px-2.5 py-1.5">
        <div className="flex items-start gap-2">
          <span className={`mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full ${data.systemStatus.color}`} />
          <div className="min-w-0">
            <div className="text-[9px] font-semibold uppercase tracking-wider text-[var(--text-muted)]">
              {data.systemStatus.label}
            </div>
            <div className="mt-0.5 text-[14px] font-semibold leading-tight text-[var(--text-primary)]">
              {data.systemStatus.headline}
            </div>
            <div className="mt-1 line-clamp-2 text-[10px] leading-4 text-[var(--text-secondary)]">
              {data.systemStatus.description}
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-1.5">
        {data.operationalKpis.map((item) => (
          <div
            key={item.label}
            className="rounded-sm border border-[var(--border-default)]/60 bg-[var(--bg-elevated)]/40 px-2 py-1.5"
          >
            <div className="text-[8px] font-semibold uppercase tracking-wider text-[var(--text-muted)]">
              {item.label}
            </div>
            <div className={`mt-0.5 text-[14px] font-semibold tabular-nums ${item.trendColor || 'text-[var(--text-primary)]'}`}>
              {item.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default OpsKaizenSystemStatus;
